import { Map as ImmutableMap } from 'immutable';

import { REDUCER_KEY } from './types';

const getResourceStore = (state: Object) => state[REDUCER_KEY];
export const getFeatureFlags = (state: any): ImmutableMap<string, any> => getResourceStore(state).featureFlags;
export const getFeatureFlag = (state: any, key: string): any => getResourceStore(state).featureFlags.get(key);
export const getLoadPending = (state) => getResourceStore(state).loadPending;
export const isLoading = (state) => getResourceStore(state).isLoading;
export const getError = (state) => getResourceStore(state).error;

export const dangerouslyUseFeatureFlags = () => window && window.dangerouslyUseFeatureFlags;
